import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('form', {
    lineHeight: '1.5em',
});

cssRule('form table', {
    borderSpacing: 0,
});

cssRule('form .tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('form .tb-enabled input.ng-invalid.ng-dirty, form textarea.ng-invalid.ng-dirty', {
    background: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('form .tb-text-input-label-cell', {
    verticalAlign: 'top',
    paddingTop: '5px',
    paddingRight: '35px',
});

cssRule('form .tb-input-wide', {
    width: '300px',
});

cssRule('form .tb-input-narrow', {
    width: '70px',
});

cssRule('form .tb-wide-overflow', {
    width: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('form .tb-textarea', {
    resize: 'none',
    margin: 0,
    outline: 0,
    padding: '6px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    font: 'inherit',
});

cssRule('form .tb-textarea:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('form .tb-textarea.tb-disabled, form .tb-textarea.tb-disabled:hover', {
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('form .tb-pop-up-menu-button-wide', {
    minWidth: '250px',
});

cssRule('form .tb-form-error', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-block', {
    display: 'block',
});

cssRule('.tb-inline', {
    display: 'inline-block',
});

cssRule('.tb-input-wide-radio-button', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '150px',
});

